import { getApiBaseUrl } from "@/utils/utils";
import axios from "axios";
import { DEFAULT_LOCALE } from "../../app/i18n";

export const apiService = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Accept-Language": DEFAULT_LOCALE },
});
